import React from 'react';
import TheObserver from '../components/TheObserver';

function TheObserverPage() {
  return <TheObserver />;
}

export default TheObserverPage;
